import { Icon, Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography/Typography';
import { OverridableStringUnion } from '@mui/types';
import styled from 'styled-components';

import { COLOR } from '@/globalStyles';

type RequestTypeProps = {
    className?: string;
    color?: string;
    icon?: string;
    name?: string;
    iconSize?: string;
    textVariant?: OverridableStringUnion<'inherit' | Variant, TypographyPropsVariantOverrides>;
};

const RequestType = ({
    className,
    color,
    icon,
    name,
    iconSize = '1.5rem',
    textVariant = 'table_text',
}: RequestTypeProps) => {
    return (
        <div className={className}>
            <Icon sx={{ color, fontSize: iconSize }}>{icon}</Icon>
            <Typography variant={textVariant} color={COLOR.zambezi}>
                {name}
            </Typography>
        </div>
    );
};

const Styled = styled(RequestType)``;
export default Styled;
